module.exports = __webpack_public_path__ + "static/4.b9ec253a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/4.png
// module id = 871
// module chunks = 69039249851653 261756379115546